import { render } from "./ShieldsType.vue?vue&type=template&id=98cfb5a2&lang=html"
import script from "./ShieldsType.vue?vue&type=script&lang=js"
export * from "./ShieldsType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__